import { Box, Text } from '@chakra-ui/react';
import { styleFontColor as style } from './utils';

export const ReasonsItem = ({ icon, title, body }) => (
  <Box
    className="reasons-item-box_item"
    border={'1px'}
    width={{ base: '100%', md: '30%' }}
    borderRadius="md"
    borderColor={style.borderColorGrey}
    mb={{ base: '8', md: '0' }}
    p={4}
  >
    <Box align={'center'} m={4}>
      {icon}
    </Box>
    <Box>
      <Text fontWeight="bold" align={'center'} mb={2}>
        {title}
      </Text>
    </Box>
    <Box>
      <Text color={style.txLightGrey} align={'center'}>
        {body}
      </Text>
    </Box>
  </Box>
);
